import React from "react";
import TeamCard from "./TeamCard";
import aritra from "../assets/images/aritra.png";
import arish from "../assets/images/arish.jfif";
import mehul from "../assets/images/mehul.png";

import "./Team.css";
import "./Features.css";
import { Typography } from "@material-ui/core";

export default function Team() {
  return (
    <div className="main-section" id="team">
      <Typography
        variant="h3"
        component="h1"
        style={{
          fontWeight: 600,
          marginTop: "3%",
          marginBottom: "-3%",
          letterSpacing: "-.02em",
          lineHeight: "1.08349",
        }}
      >
        Meet the Team
      </Typography>
      <div className="team">
        <TeamCard
          name="Aritra Kar"
          description="2nd year Honors Computer Science (Co-op) student at the University of Waterloo.
          Coded the website and assisted in developing  the backend of the iOS app."
          src={aritra}
          linkedin="https://www.linkedin.com/in/aritra-kar-a792751a6/"
        />
        <TeamCard
          name="Arish Tripathi"
          description="3rd year Information Technology Management for Business student at the University of Manchester.
          Coded the iOS app."
          src={arish}
          linkedin="https://www.linkedin.com/in/arish-tripathi-43344514a/"
        />
        <TeamCard
          name="Mehul Bhargava"
          description=" 2nd year Design student at the Pratt Institute of Design, New York.
          Designed the app."
          src={mehul}
          linkedin="https://www.linkedin.com/in/mehul-bhargava-3b821b189/"
        />
      </div>
      <div
        className="spacer waves7"
        style={{ zIndex: 100, marginTop: "-5%", marginBottom: "-25%" }}
      ></div>
    </div>
  );
}
